// src/hooks/useWebSocket.js
import { useEffect, useRef, useCallback } from 'react';

export function useWebSocket(onMessage) {
  const wsRef      = useRef(null);
  const retryRef   = useRef(null);
  const mountedRef = useRef(true);

  const connect = useCallback(() => {
    const token = localStorage.getItem('kindeo_token');
    if (!token) return;

    const wsUrl = `${process.env.REACT_APP_WS_URL || 'ws://localhost:3000/ws'}?token=${token}`;
    const ws    = new WebSocket(wsUrl);
    wsRef.current = ws;

    ws.onopen = () => {
      console.log('🔌 WebSocket connecté');
      if (retryRef.current) { clearTimeout(retryRef.current); retryRef.current = null; }
    };

    ws.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data);
        onMessage?.(payload);
      } catch { /* ignorer */ }
    };

    ws.onclose = () => {
      if (!mountedRef.current) return;
      // Reconnexion automatique après 3s
      retryRef.current = setTimeout(() => { if (mountedRef.current) connect(); }, 3000);
    };

    ws.onerror = () => ws.close();
  }, [onMessage]);

  useEffect(() => {
    connect();
    return () => {
      mountedRef.current = false;
      if (retryRef.current) clearTimeout(retryRef.current);
      wsRef.current?.close();
    };
  }, [connect]);

  return wsRef;
}
